import { render, staticRenderFns } from "./CancelationPolicy.vue?vue&type=template&id=0da49df6"
import script from "./CancelationPolicy.vue?vue&type=script&lang=js"
export * from "./CancelationPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da49df6')) {
      api.createRecord('0da49df6', component.options)
    } else {
      api.reload('0da49df6', component.options)
    }
    module.hot.accept("./CancelationPolicy.vue?vue&type=template&id=0da49df6", function () {
      api.rerender('0da49df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_cancelation_policy/CancelationPolicy.vue"
export default component.exports